import React, { useState, useMemo } from "react";
import { Store, Search } from "lucide-react";

// Imports từ các component đã tách
import { RAW_MERCHANT_DATA } from '../../../utils/data';
import ShopDetailModal from './components/ShopDetailModal';
import DashboardStats from './components/DashboardStats';
import WorkspaceTable from './components/WorkspaceTable';
import Pagination from './components/Pagination';

const WorkspacesManager = () => {
  // State
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [selectedShop, setSelectedShop] = useState(null);

  // Filter Logic
  const filteredShops = useMemo(() => {
    return RAW_MERCHANT_DATA.filter((shop) => {
      const term = searchTerm.toLowerCase();
      return (
        shop.workspaceName?.toLowerCase().includes(term) ||
        shop.userName?.toLowerCase().includes(term) ||
        shop.terminalID?.toLowerCase().includes(term) ||
        shop.merchantAddress?.toLowerCase().includes(term)
      );
    });
  }, [searchTerm]);

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredShops.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filteredShops.length / itemsPerPage);

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleRowClick = (shop) => {
    setSelectedShop(shop);
  };

  // Stats Logic
  const stats = useMemo(() => {
    const total = RAW_MERCHANT_DATA.length;
    const hasLicense = RAW_MERCHANT_DATA.filter(
      (s) => s.businessRegistrationNumber
    ).length;
    const hasType = RAW_MERCHANT_DATA.filter((s) => s.businessType).length;

    return { total, hasLicense, hasType };
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-800 relative">
      {/* Modal Detail */}
      <ShopDetailModal shop={selectedShop} onClose={() => setSelectedShop(null)} />

      {/* Header */}
      <header className="bg-white shadow-sm border-b top-0 z-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3 text-blue-700">
            <div className="bg-blue-600 text-white p-1.5 rounded-lg shadow-sm">
              <Store className="h-6 w-6" />
            </div>
            <h1 className="text-xl font-bold text-slate-900 tracking-tight">
              Quản lý Cửa hàng
            </h1>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* Dashboard Stats */}
        <DashboardStats stats={stats} />

        {/* Search Input */}
        <div className="bg-white rounded-t-xl border border-slate-200 border-b-0 p-4">
          <div className="relative max-w-lg">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 h-5 w-5" />
            <input
              type="text"
              placeholder="Tìm tên cửa hàng, Terminal ID, chủ sở hữu..."
              className="pl-10 pr-4 py-2.5 w-full border border-slate-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none text-sm shadow-sm transition-all"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
                setCurrentPage(1);
              }}
            />
          </div>
        </div>

        {/* Data Table */}
        <WorkspaceTable data={currentItems} onRowClick={handleRowClick} />

        {/* Pagination */}
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={filteredShops.length}
          itemsPerPage={itemsPerPage}
          onPageChange={handlePageChange}
          startIndex={indexOfFirstItem}
        />
      </main>
    </div>
  );
};

export default WorkspacesManager;